import { useLazyQuoteApi } from 'Shared/services/Api/makeQuoteApiHttp';
import { transformAvailableProductsResponse } from 'QuoteApp/services/endpoints/GetAvailableProducts';
import { GetAvailableProductsResponseType } from 'QuoteApp/services/endpoints/GetAvailableProducts';

export type AvailableProductsProviderType = {
  availableProducts: GetAvailableProductsResponseType | null;
  availableProductsLoading: boolean;
  refreshAvailableProducts(): Promise<GetAvailableProductsResponseType>;
};

export const useAvailableProducts = (
  appId: string
): AvailableProductsProviderType => {
  const [{ data, loading }, fetch] =
    useLazyQuoteApi<GetAvailableProductsResponseType>({
      method: 'GET',
      url: `insurance_applications/${appId}/available_products`,
      transformResponse: transformAvailableProductsResponse,
    });

  const refreshAvailableProducts = async () => {
    return (await fetch()).data;
  };

  return {
    availableProducts: data,
    availableProductsLoading: loading,
    refreshAvailableProducts,
  };
};
